import { render, staticRenderFns } from "./DeleteTemplateModal.vue?vue&type=template&id=3bcaa4dc"
import script from "./DeleteTemplateModal.vue?vue&type=script&lang=js"
export * from "./DeleteTemplateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bcaa4dc')) {
      api.createRecord('3bcaa4dc', component.options)
    } else {
      api.reload('3bcaa4dc', component.options)
    }
    module.hot.accept("./DeleteTemplateModal.vue?vue&type=template&id=3bcaa4dc", function () {
      api.rerender('3bcaa4dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/DeleteTemplateModal.vue"
export default component.exports